import { FC, HTMLAttributes } from "react";
import { useStyles } from "./NoRewardView.style";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import LightEffect from "../../../assets/result/bg_light_effect_1x.webp";
import LightEffect2x from "../../../assets/result/bg_light_effect_2x.webp";
import LightEffect3x from "../../../assets/result/bg_light_effect_3x.webp";
import GemLeft from "../../../assets/result/gem_left_3x.webp";
import GemRight from "../../../assets/result/gem_right_3x.webp";
import GemMiddle from "../../../assets/result/gem_middle_3x.webp";
import GemTop from "../../../assets/result/gem_top_3x.webp";
import { useTranslation } from "react-i18next";

// interface IGamesSection {}

export const NoRewardView: FC<HTMLAttributes<HTMLDivElement>> = () => {
  // const {} = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.noRewardView}>
      <Typography
        className={classes.title}
        variant={TypographyVariant.HeadingH4Bold}
      >
        {t("no_rewards")}
      </Typography>
      <div className={classes.result}>
        <Image
          src={LightEffect}
          src2x={LightEffect2x}
          src3x={LightEffect3x}
          className={classes.img}
        />
        <div className={classes.gem}>
          <Image src={GemLeft} className={classes.gemLeft} />
          <Image src={GemMiddle} className={classes.gemMiddle} />
          <Image src={GemTop} className={classes.gemTop} />
          <Image src={GemRight} className={classes.gemRight} />
        </div>
      </div>
    </div>
  );
};

export default NoRewardView;
